import { t } from 'i18next';
import * as yup from 'yup';

export const updateRequestSchema = () =>
  yup.object().shape({
    levelId: yup.number().label(t('labelSupportRequestLevel')).nullable(),
    statusId: yup.number().label(t('labelSupportRequestStatus')).nullable(),
    requiredByDate: yup
      .string()
      .label(t('labelRequestedDate'))
      .nullable(),
  });
